import { mainBeforeEnter } from '@/common/util/common'
import { PATH_NAME_HOME } from '@/common/router.const'

export default [
  {
    path: '/',
    name: PATH_NAME_HOME,
    components: {
      homeLayout: () => import('@/views/home/HomeLayout'),
    },
    children: [
      {
        path: '',
        alias: 'index.html',
        name: PATH_NAME_HOME,
        props: true,
        components: {
          home: () =>
            import(/* webpackChunkName: "Home" */ '@/views/home/HomeView.vue'),
        },
        beforeEnter: mainBeforeEnter,
      },
    ],
  },
]
